import { BAOCustomElement } from '@bao/custom-element'
import { eventBus, EVENTS } from '@bao/events'
import { sectionRenderer } from '@bao/section-rendering'

class ProductRecommendations extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.load || !this.url) return
    this.fetchRecommendations()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.dynamic) return
    this.onCartChanged = this.onCartChanged.bind(this)
    eventBus.addEventListener(EVENTS.PUSH_CART.CHANGED, this.onCartChanged)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (!this.dynamic) return
    eventBus.removeEventListener(EVENTS.PUSH_CART.CHANGED, this.onCartChanged)
  }

  async fetchRecommendations () {
    try {
      let response = await fetch(this.url)
      response = await response.text()

      const newDOM = sectionRenderer.convertToDOM(response)
      const myself = newDOM.querySelector(this.localName)
      if (!myself) return
      this.innerHTML = myself.innerHTML
    } catch (error) {
      console.error('Failed to load product recommendations', error)
    }
  }

  async onCartChanged () {
    try {
      const response = await sectionRenderer.fetchSingle(
        this.sectionId,
        window.location.href,
      )

      const newDOM = sectionRenderer.convertToDOM(response)
      const myself = newDOM.querySelector(this.localName)
      this.outerHTML = myself.outerHTML
    } catch (error) {
      console.error('Failed to update product recommendations section', error)
    }
  }

  get dynamic () {
    return this.dataset.dynamic === 'true'
  }

  get load () {
    return this.dataset.load !== 'false'
  }

  get sectionId () {
    return this.dataset.sectionId
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations)
}
